/**
 * Handles click events on non semantic button elements
 * Returns whether the given event is a click event or
 * the space bar or enter key has been pressed.
 */
export default function a11yClick(event: Event): boolean {
  if (event.type === 'click') {
    return true;
  }

  if (event.type === 'keydown' || event.type === 'keypress') {
    const {key} = event as KeyboardEvent;

    if (key === ' ' || key === 'Spacebar' || key === 'Enter') {
      event.preventDefault();
      return true;
    }
  }

  return false;
}
